<template>
  <router-view />
</template>
<script>
import { windowOnresize } from '@/utils/fnc';
export default {
  mounted() {
    windowOnresize();
  },
};
</script>
